<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    {{ players }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    computed: {

        players: function() {

            var names = []

            this.$_.each(this.item.players, function(player) {

                names.push(player.fullname || player.name)

            })

            return names.join(', ')

        }

    }

}

</script>

<style scoped>

</style>